export class AddNotification {
  public static readonly type = '[Notifications] AddNotification';
  constructor(public readonly message: string) {}
}
